export const ApiQuerySpaceTemplates = Symbol('ApiQuerySpaceTemplates');
